import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WorkIcon from "@mui/icons-material/Work";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import EmailIcon from "@mui/icons-material/Email";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Button from "../../atoms/Button/Button";
import "./AlertsBanner.css";

const AlertsBanner = ({ onSubscribeAlerts }) => (
  <section id="notifications">
    <div className="wrap">
      <div className="alerts-banner">
        <div className="alerts-banner-head">
          <NotificationsActiveIcon />
          <h3>Information au quotidien pour tous</h3>
        </div>
        <p>
          Vous pouvez recevoir un e-mail quotidien de la situation prévisionnelle « Risques feux de forêt » dans votre département.
        </p>
        <div className="alerts-banner-features">
          <span>
            <LocationOnIcon fontSize="inherit" />
            Jusqu'à 2 départements sélectionnés
          </span>
          {/* <span>
            <WorkIcon fontSize="inherit" />
            Uniquement des adresses professionnelles
          </span> */}
          <span>
            <AutorenewIcon fontSize="inherit" />
            Désinscription simple par e-mail à info@ensemblepourlaforet.fr  
          </span>
        </div>

        <div className="alerts-banner-actions">
          <Button label="S'informer au quotidien" variant="primary" to="/register" />
          {/* <a className="alerts-banner-download" href="/files/secufire-action-presentation.pdf" download>
            <FileDownloadIcon fontSize="inherit" />
            Télécharger la présentation de SecuFire Action
          </a> */}
        </div>

        <div className="alerts-banner-contact">
          <div className="contact-block">
            <EmailIcon className="contact-icon" />
            <div>
              <span className="contact-label">Pour toute demande spécifique, contactez :</span>
              <a
                href="mailto:info@ensemblepourlaforet.fr?subject=Demandes%20sp%C3%A9cifiques"
                className="contact-email"
              >
                info@ensemblepourlaforet.fr
              </a>
            </div>
          </div>
          <div className="contact-block presse-block">
            <EmailIcon className="contact-icon" />
            <div>
              <span className="contact-label">Médias, contactez :</span>
              <a
                href="mailto:presse@climateimpactedhec.com?subject=Demande%20M%C3%A9dia"
                className="contact-email"
              >
                presse@climateimpactedhec.com
              </a>
            </div>
          </div>
        </div>
        {/* <p className="alerts-banner-note">
          Conditions d'utilisation : <a href="#mentions">voir module 7</a>.
        </p> */}
      </div>
    </div>
  </section>
);

export default AlertsBanner;